// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Action, createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthActionsUnion, Token, AuthActionTypes, OIDCUser } from './auth.actions';

export const AUTH_FEATURE_NAME = 'auth';

export interface AuthState {
  token?: Token;
  isRefreshingToken: boolean;
}

export const initialState = {
  isRefreshingToken: false
};

export const getAuthState = createFeatureSelector<AuthState>(AUTH_FEATURE_NAME);

export const getTokenState = createSelector(getAuthState, authState => {
  if (authState === undefined || authState.token === undefined) {
    return;
  }
  return authState.token;
});

export const getLoggedInState = createSelector(getTokenState, authToken => {
  return authToken !== undefined;
});

export const getOIDCUser = createSelector(getTokenState, token => {
  return token && new OIDCUser(token);
});

export const getIsRefreshingToken = createSelector(getAuthState, authState => authState.isRefreshingToken);

export function authReducer(state: Readonly<AuthState> = initialState, action: Action): Readonly<AuthState> {
  const authAction = action as AuthActionsUnion;
  switch (authAction.type) {
    case AuthActionTypes.LOGIN:
      return {
        ...state,
        isRefreshingToken: false,
        token: authAction.payload
      };
    case AuthActionTypes.LOGOUT:
      const { token, ...remainder } = state;
      return remainder;
    case AuthActionTypes.TRIGGER_LOGIN_REFRESH:
      return {
        ...state,
        isRefreshingToken: true
      };
    case AuthActionTypes.FAIL_LOGIN_REFRESH:
      return {
        ...state,
        isRefreshingToken: false
      };
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/app/core/state/auth.reducer.ts